import { gql } from 'graphql-tag'
import { seoFragment } from '../fragments/seo.js'

export const getHome = gql`
  ${seoFragment}
  query GetHome($site: [String]) {
    homepageEntries(site: $site) {
      ... on homepage_Entry {
        id
        seo {
          ...SeoFragment
        }
        generalHeader {
          ... on generalHeader_Entry {
            id
            generalHeaderTitle
            generalHeaderText
            sezioneImmagineVideoFull {
              ... on sezioneImmagineVideoFull_Entry {
                imageVideoTitle
                imageVideoText
                fullVideoUrlPreview
                fullVideoUrl
                fullVideoButtonText
                fullImage {
                  id
                  title
                }
                landscape: fullImage
                  @transform(format: "webp", width: 3840, height: 2160) {
                  id
                  url
                  srcset(sizes: ["750w", "1300w", "1920w"])
                  width
                  height
                  title
                }
                mobile: fullImageMobile
                  @transform(format: "webp", width: 1000, height: 1500) {
                  id
                  url
                  srcset(sizes: ["750w", "1000w"])
                  width
                  height
                  title
                }
              }
            }
          }
        }
        carosello {
          ... on carosello_Entry {
            sectionTitle
            text
            mostraBottoneCarosello {
              ... on mostraBottoneCarosello_Entry {
                linkDefault
                label
              }
            }
            mostraListaLinkCarosello {
              ... on mostraListaLinkCarosello_Entry {
                listaLink {
                  ... on linkItem_Entry {
                    label
                    linkDefault
                  }
                }
              }
            }
            slide {
              ... on slide_Entry {
                sectionTitle
                coloreTitolo
                text
                linkDefault
                label
                portrait: immagine @transform(width: 800, height: 800) {
                  id
                  url
                  srcset(sizes: ["750w", "1000w"])
                  width
                  height
                  title
                }
              }
              ... on riferimentoNews_Entry {
                riferimentoNews {
                  ... on news_Entry {
                    slug
                    title
                    introNews {
                      html
                    }
                  }
                }
              }
            }
          }
        }
        sezioneImmagineTesto {
          ... on sezioneImmagineTesto_Entry {
            id
            portrait: immagine
              @transform(format: "webp", width: 1500, height: 1780) {
              id
              url
              srcset(sizes: ["750w", "1000w"])
              width
              height
              title
            }
            coloreTitolo
            coloreSfondo
            sectionTitle
            text
            invertiOrdine
            linkDefault
            label
          }
        }
      }
    }
  }
`
